<ng-container *ngIf="loadCount$ | async"></ng-container>
<ng-container *ngIf="getOutDatedCountByFilterData$ | async"></ng-container>
<ng-container *ngIf="loadInfo$ | async as loadInfo">
  @let isTopInfobar = false;
  <!-- (!loadInfo.hasSubscription && !loadInfo.forceAllow && loadInfo.hasTestTime); -->
  @let isTopHeader = (loadInfo.hasSubscription || loadInfo.hasTestTime || loadInfo.forceAllow);
  <!-- Top info banner -->
  <header *transloco="let translate">
    @if (isTopInfobar) {
    <mt-top-info-banner
      [hasSubscription]="loadInfo.hasSubscription"
      [hasTestTime]="loadInfo.hasTestTime"
      [trialDaysLeft]="loadInfo.trialDaysLeft"
      [forceAllow]="loadInfo.forceAllow"
      [isUserFromAngularTs]="loadInfo.isUserFromAngularTs"
      [accountData]="loadInfo.accountData.accountData"
      [adminAccounts]="loadInfo.accountData.adminAccounts"
      [allCustomers]="loadInfo.allCustomers"
      [recentCustomersEmail]="loadInfo.recentCustomersEmail"
      [superAdminAccountData]="loadInfo.superAdminAccountData"
      (searchValue)="topInfoBannerService.refreshSearchValue($event)"
      (customerLogin)="topInfoBannerService.customerLogin($event, loadInfo.recentCustomersEmail)"
      (changeAccount)="topInfoBannerService.changeAccount($event)"
      (logout)="topInfoBannerService.doLogout()"
    >
    </mt-top-info-banner>
    }
    @if (isTopHeader) {
      <div class="nav-wrapper d-flex align-items-center header-container mx-auto gap-5 py-2">
        <a [routerLink]="['/dashboard']" class="logo-block">
          <img src="assets/images/Signitic Mailtastic.png" alt="Mailtastic" />
        </a>
        <nav>
          <ul class="d-flex navlink-wrap list-unstyled mb-0 parent-wrap gap-4">
            <li class="nav-item">
              <a [routerLink]="['/dashboard']" class="menu-link" mtMultiRouterLinkActive [multiRouterLinkActive]="['/dashboard']" activeClass="active">
                {{ translate('dashboard_title') }}
              </a>
            </li>
            @for (menu of sidebarMenus.mainMenus; track menu) {
                @if (getMyIntegrations$ | async; as myIntegrations) {
                  @switch (menu.name) {
                    @case ('employees') {
                      <!-- Employee menu options -->
                      <li class="nav-item position-relative">
                        <a class="menu-link" mtMultiRouterLinkActive [multiRouterLinkActive]="menu.routeList || []" activeClass="active">{{ translate(menu.title || '') }}</a>
                        <mt-navigation-header-employee-submenu
                          [allEmployeeCount]="submenuCounters.employees"
                          [myIntegrations]="myIntegrations"
                          [outdatedEmployeeCount]="submenuCounters.employeesOutdated"
                          [groupCount]="submenuCounters.departments"
                        ></mt-navigation-header-employee-submenu>
                      </li>
                    }
                    @case ('signatures') {
                      <!-- Signature menu options -->
                      <li 
                        class="nav-item position-relative"
                        mt-claim-authorization
                        [requiredClaims]="['Signature:View', 'DefaultSignatures:View']"
                      >
                        <a class="menu-link" mtMultiRouterLinkActive [multiRouterLinkActive]="menu.routeList || []" activeClass="active">{{ translate(menu.title || '') }}</a>
                        <mt-navigation-header-signature-submenu
                          [signatureCount]="submenuCounters.signatures"
                        ></mt-navigation-header-signature-submenu>
                      </li>
                    }
                    @case ('campaigns') {
                      <!-- Marketing menu options -->
                      <li 
                        class="nav-item position-relative"
                        mt-claim-authorization
                        [requiredClaims]="[
                          'Campaign:View',
                          'Event:View',
                          'TargetGroups:View'
                        ]"
                      >
                        <a class="menu-link" mtMultiRouterLinkActive [multiRouterLinkActive]="menu.routeList || []" activeClass="active">{{ translate(menu.title || '') }}</a>
                        <mt-navigation-header-marketing-submenu
                          [campaignCount]="submenuCounters.campaigns"
                          [eventCount]="submenuCounters.events"
                          [targetGroupCount]="submenuCounters.targetGroups"
                          [notificationCount]="submenuCounters.notifications"
                          [authorizationScope]="loadInfo.authorizationScope"
                        ></mt-navigation-header-marketing-submenu>
                      </li>
                    }
                    @case ('integrations') {
                      <!-- Integration menu options -->
                      <li class="nav-item position-relative">
                        <a class="menu-link" mtMultiRouterLinkActive [multiRouterLinkActive]="menu.routeList || []" activeClass="active">{{ translate(menu.title || '') }}</a>
                        <mt-navigation-header-integration-submenu
                          [activeIntegrationCount]="myIntegrations.length"
                        ></mt-navigation-header-integration-submenu>
                      </li>
                    }
                  }
                }
            }
          </ul>
        </nav>
        <div class="ms-auto d-flex gap-4">
          <!-- <mt-button mt-claim-authorization [requiredClaims]="['Billing:View']" class="plan-btn" color="secondary_v2" text="Upgrade" icon="flash" [routerLink]="['/booking']"></mt-button> -->

          <div mt-claim-authorization [requiredClaim]="'Administration:Manage'" ngbDropdown class="d-inline-block" placement="bottom-end">
            <button
              type="button"
              class="btn btn-link p-0 profile-dropdown rounded-pill border-0 p-2 text-decoration-none d-flex"
              id="dropdownBasic2"
              ngbDropdownToggle
            >
              <img class="header-svg-icon" src="assets/images/svgs/settings.svg" alt="settings" />
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
              <mt-navigation-header-settings-submenu
                [authorizationScope]="loadInfo.authorizationScope"
                [forceAllow]="loadInfo.forceAllow"
                [hasChargifySubscription]="loadInfo.hasChargifySubscription"
                [hasSubscription]="loadInfo.hasSubscription"
                [portalUrlData]="portalUrlData()"
                (openNoWorkspaceModal)="openNoWorkspaceModal()"
              ></mt-navigation-header-settings-submenu>
            </div>
          </div>

          <div ngbDropdown class="d-inline-block" placement="bottom-end">
            <button
              type="button"
              class="btn btn-link p-0 profile-dropdown rounded-pill border-0 p-2 text-decoration-none"
              id="dropdownBasic2"
              ngbDropdownToggle
            >
              <img class="header-svg-icon" src="assets/images/svgs/domain_list_svg.svg" alt="language" />
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="language-dropdownmenu">
              <ng-container *ngFor="let language of languages; let i = index">
                @let isAvtiveLanguage = translateService.getActiveLang() === language.key;
                <button type="button" class="edit profile-item {{isAvtiveLanguage ? 'active-item' : ''}}" ngbDropdownItem (click)="languageService.changeLanguage(language.key)">
                  <span class="cursor-pointer">{{ language.fullname }}</span>
                  @if (isAvtiveLanguage) {
                    <mt-svg class="mt-submenu-icon mt-brand-100" src="assets/images/buttons/tick_btn_svg.svg"></mt-svg>
                  }
                </button>
              </ng-container>
            </div>
          </div>

          <div ngbDropdown class="d-inline-block" placement="bottom-end">
            <button
              type="button"
              class="btn btn-link p-0 profile-dropdown rounded-pill fw-bold text-decoration-none"
              id="dropdownBasic1"
              ngbDropdownToggle
            >
              {{ loadInfo.accountData.accountData | shortName }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="profile-dropdownmenu">
              <div class="d-flex gap-1 flex-column">
                
                <div class="d-flex profile-item">
                  <div class="user-data w-20 flex-grow-1" data-cy="user-data">
                    <div class="fw-bold name text-black" data-cy="user-name">
                      {{ loadInfo.accountData.accountData.firstName }} {{ loadInfo.accountData.accountData.lastName }}
                    </div>
                    <div
                      placement="left"
                      class="email text-truncate text-black"
                      [ngbTooltip]="loadInfo.accountData.accountData.email"
                      tooltipClass="inner_tooltip"
                      data-cy="user-email"
                    >
                      {{ loadInfo.accountData.accountData.email | textTruncate: 28 }}
                    </div>
                  </div>
                  @if (loadInfo.accountData.accountData.companyName) {
                  <div class="">
                    <div
                      ngbDropdown
                      class="d-block"
                      #myDrop="ngbDropdown"
                      data-cy="accounts-dropdown"
                      placement="bottom-end"
                    >
                      <button
                        class="btn btn-link p-0 profile-dropdown rounded-pill border-0 p-2 text-decoration-none switch-company"
                        ngbDropdownToggle
                      >
                        <span
                          *ngIf="loadInfo.accountData.accountData.companyName"
                          [ngbTooltip]="loadInfo.accountData.accountData.companyName"
                          tooltipClass="inner_tooltip"
                        >
                          <img src="assets/images/svgs/swap.svg" alt="Swap" />
                          <!-- {{ loadInfo.accountData.accountData.companyName | textTruncate: 23 }}</span -->
                          <!-- > -->
                        </span>
                      </button>
                      <ul ngbDropdownMenu class="dropdown-menu-left full-width force-scroll">
                        <input
                          data-cy="search-account"
                          type="text"
                          [formControl]="searchTxt"
                          placeholder="{{ 'Search' | transloco }}"
                          class="form-control menu-left-input"
                        />
                        <ng-container *ngIf="filteredAccounts$ | async as filteredAccounts">
                          <li *ngFor="let data of filteredAccounts" (click)="topInfoBannerService.changeAccount(data.id)">
                            <a
                              [ngbTooltip]="data.companyName.length > 23 ? data.companyName : ''"
                              tooltipClass="inner_tooltip"
                              ngbDropdownItem
                              >{{ data.companyName | textTruncate: 23 }}</a
                            >
                          </li>
                          <li class="txt-gray" *ngIf="filteredAccounts.length === 0">
                            <a transloco="account_not_found" data-cy="account-not-found"> </a>
                          </li>
                        </ng-container>
                        <li>
                          <a ngbDropdownItem transloco="view_all" [routerLink]="['/account/select']"></a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  }
                </div>

                <div *ngIf="loadInfo.superAdminAccountData.isSuperAdmin">
                  <div class="divider"></div>
                  <mt-top-info-banner-super-admin
                    [allCustomers]="loadInfo.allCustomers"
                    [superAdminAccountData]="loadInfo.superAdminAccountData"
                    [accountData]="loadInfo.accountData.accountData"
                    [recentCustomersEmail]="loadInfo.recentCustomersEmail"
                    (searchValue)="topInfoBannerService.refreshSearchValue($event)"
                    (customerLogin)="topInfoBannerService.customerLogin($event, loadInfo.recentCustomersEmail)"
                  ></mt-top-info-banner-super-admin>
                </div>

                <div class="divider"></div>

                <button type="button" class="edit profile-item" ngbDropdownItem [routerLink]="['/settings/administration']">
                  <mt-svg
                    src="assets/images/svgs/user.svg"
                    class="mt-submenu-icon mt-brand-100 d-flex"
                  ></mt-svg>
                  <span data-cy="administrator" class="cursor-pointer edit-btn">{{ translate('edit_profile') }}</span>
                </button>

                <ng-container *ngFor="let middleMenus of sidebarMenus.settings_middle">
                  <a
                    href="{{ middleMenus.url! | transloco }}"
                    [target]="middleMenus.name === 'nav_help_center' ? '_blank' : '_self'"
                    class="edit profile-item" ngbDropdownItem
                  >
                    @let svgIcon = middleMenus.name === 'nav_help_center' ? 'question-circle' : middleMenus.name === 'resources' ? 'article' :'exclamation';
                    <mt-svg
                      src="assets/images/svgs/{{svgIcon}}.svg"
                      class="mt-submenu-icon mt-brand-100 d-flex"
                    ></mt-svg>
                    <span data-cy="administrator" class="cursor-pointer">{{ translate(middleMenus.name) }}</span>
                </a>
                </ng-container>

                <button class="profile-item" ngbDropdownItem (click)="topInfoBannerService.doLogout()">
                  <mt-svg
                    src="assets/images/svgs/logout.svg"
                    class="mt-submenu-icon mt-brand-100 d-flex"
                  ></mt-svg>
                  <span data-cy="administrator" class="cursor-pointer logout-btn">{{ translate('logout') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </header>

  <div class="page-container " [ngStyle]="{'margin-top': !!isTopInfobar ? '113px' : !!isTopHeader ? '63px' : '0px'}">
    <!-- DEPRECATED -->
    <!-- <nav
      *ngIf="loadInfo.hasSubscription || loadInfo.hasTestTime || loadInfo.forceAllow"
      class="page-sidebar d-none"
      [ngClass]="{
        'page-sidebar_floating': !loadInfo.submenuLocked || !loadInfo.submenuOpened
      }"
      (mouseleave)="clickOutside(loadInfo.submenuLocked, $event)"
    >
      <div class="sidebar-fixed">
        <mt-navigation-sidebar-menu-header
          [className]="loadInfo | headerAdjustment: isCognismSignatures"
          (closeSubmenuSidebar)="closeSubmenuSidebar(loadInfo.submenuLocked)"
        ></mt-navigation-sidebar-menu-header>

        <div class="flex sidebarcolumnlayout">
          <mt-navigation-sidebar-main-menus
            [isGuideMenuHidden]="loadInfo.isGuideMenuHidden.status"
            [topMenus]="sidebarMenus.topMenus"
            [bottomMenus]="sidebarMenus.bottomMenus"
            [isUserOnBasicPlan]="loadInfo.authorizationScope.isUserOnBasicPlan"
            [activeRoute]="activeRoute"
            [tooltips]="tooltips"
            [submenuSection]="submenuSection"
            [submenuOpened]="loadInfo.submenuOpened"
            [routeString]="route.snapshot.firstChild?.routeConfig?.path || ''"
            (showTooltip)="showTooltip($event)"
            (hideTooltip)="hideTooltip($event)"
            (toggleSubmenuSidebar)="toggleSubmenuSidebar($event, loadInfo.submenuLocked, loadInfo.submenuOpened)"
            (showSettingsTooltip)="showSettingsTooltip($event, loadInfo.submenuLocked, loadInfo.submenuOpened)"
            (hideSubmenu)="hideSubmenu()"
            (showHideLanguageSubtooltip)="showHideLanguageSubtooltip()"
            (showHideSettingsTooltip)="showHideSettingsTooltip($event)"
            (hideSettingsTooltip)="hideSettingsTooltip($event)"
          ></mt-navigation-sidebar-main-menus>
        </div>
      </div>

      <div
        class="mt-submenu-sidebar-wrapper padtop10"
        [ngClass]="{
          'mt-submenu-sidebar-wrapper_floating': !loadInfo.submenuLocked,
          'cognism-signatures': isCognismSignatures,
          martop0imp: isCognismSignatures && (!loadInfo.isGuideExist || loadInfo.isGuidePage.isGuidePage),
          'mt-submenu-sidebar-wrapper-trial-area-shown':
            isCognismSignatures || (loadInfo | topAreaShown: isCognismSignatures)
        }"
        *ngIf="loadInfo.submenuOpened"
      >
        <ng-container>
          <div *ngFor="let submenus of sidebarMenus.submenus">
            <div
              (clickOutside)="clickOutside(loadInfo.submenuLocked)"
              class="mt-submenu-sidebar-inner-wrapper sidebar-submenus"
              *ngIf="isSubmenuSectionActive(submenus.name, loadInfo.submenuOpened)"
            >
              <mt-navigation-sidebar-submenu-header
                [submenuTitle]="submenus.title || ''"
                [submenuLocked]="loadInfo.submenuLocked"
                (toggleSubmenuLock)="toggleSubmenuLock(loadInfo.submenuLocked)"
              ></mt-navigation-sidebar-submenu-header>

              <ng-container *ngIf="getMyIntegrations$ | async as myIntegrations">
                <ng-container [ngSwitch]="submenus.name">
                  <mt-navigation-header-employee-submenu
                    *ngSwitchCase="'employees'"
                    [allEmployeeCount]="submenuCounters.employees"
                    [myIntegrations]="myIntegrations"
                    [outdatedEmployeeCount]="submenuCounters.employeesOutdated"
                    [groupCount]="submenuCounters.departments"
                  ></mt-navigation-header-employee-submenu>

                  <mt-navigation-header-signature-submenu
                    *ngSwitchCase="'signatures'"
                    [signatureCount]="submenuCounters.signatures"
                  ></mt-navigation-header-signature-submenu>

                  <mt-navigation-header-marketing-submenu
                    *ngSwitchCase="'campaigns'"
                    [campaignCount]="submenuCounters.campaigns"
                    [eventCount]="submenuCounters.events"
                    [targetGroupCount]="submenuCounters.targetGroups"
                    [notificationCount]="submenuCounters.notifications"
                    [authorizationScope]="loadInfo.authorizationScope"
                  ></mt-navigation-header-marketing-submenu>

                  <mt-navigation-header-integration-submenu
                    *ngSwitchCase="'integrations'"
                    [activeIntegrationCount]="myIntegrations.length"
                  ></mt-navigation-header-integration-submenu>

                  <mt-navigation-header-settings-submenu
                    *ngSwitchCase="'settings'"
                    [authorizationScope]="loadInfo.authorizationScope"
                    [forceAllow]="loadInfo.forceAllow"
                    [hasChargifySubscription]="loadInfo.hasChargifySubscription"
                    [hasSubscription]="loadInfo.hasSubscription"
                  ></mt-navigation-header-settings-submenu>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </nav> -->

    <!-- Router Outlet -->
    <router-outlet class="body"></router-outlet>

    <!-- Intercom -->
    <div class="adblock-exclamation-mark" *ngIf="(isIntercomExist$ | async) === false">
      <img src="assets/images/adblock/notification_icon.png" (click)="adblockService.openAdblockContentModal()" />
    </div>
  </div>
</ng-container>
